const contactInfo = [
  {
    group: 'Address',
    icon: 'ri-map-pin-2-line',
    lines: [
      { label: 'Street', value: 'Centur 16' },
      { label: 'City', value: 'Marezige' },
      { label: 'Zip', value: '6273' },
      { label: 'Country', value: 'Slovenia' },
    ],
  },
  {
    group: 'Contact',
    icon: 'ri-contacts-line',
    lines: [
      { label: 'Email', value: 'info@korendoo.com' },
      { label: 'Number', value: '+1 7125269652' },
    ],
  },
];

export default function ContactSection() {
  return (
    <footer id="contact" className="bg-[#1e2128]">
      {/* Main contact area */}
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row lg:items-start lg:gap-20">
          {/* Brand column */}
          <div className="lg:w-5/12 mb-14 lg:mb-0">
            <p
              className="text-xs uppercase tracking-[0.3em] text-white/40 font-semibold mb-5"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Get In Touch
            </p>
            <h2
              className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              KOREN d.o.o.
            </h2>
            <p className="text-white/50 text-base leading-relaxed max-w-sm">
              A team of experts developing modern iOS applications focused on security,
              performance, and exceptional user experience.
            </p>

            {/* Decorative line */}
            <div
              className="mt-10 w-16 h-1 rounded-full"
              style={{ background: 'linear-gradient(90deg, #10b981, #14b8a6)' }}
            />
          </div>

          {/* Info columns */}
          <div className="lg:w-7/12 grid grid-cols-1 sm:grid-cols-2 gap-10 md:gap-14">
            {contactInfo.map((group) => (
              <div key={group.group}>
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-emerald-500/10">
                    <i className={`${group.icon} text-emerald-400 text-base`} />
                  </div>
                  <span
                    className="text-xs uppercase tracking-[0.25em] text-white/40 font-semibold"
                    style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                  >
                    {group.group}
                  </span>
                </div>
                <ul className="flex flex-col gap-4">
                  {group.lines.map((line) => (
                    <li key={line.label} className="flex flex-col gap-0.5">
                      <span className="text-xs text-white/30 uppercase tracking-wider font-medium">
                        {line.label}
                      </span>
                      <span className="text-white/80 text-base font-medium">{line.value}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-sm">
            &copy; {new Date().getFullYear()} KOREN d.o.o. All rights reserved.
          </p>
          <p className="text-white/20 text-xs">
            Marezige, Slovenia
          </p>
        </div>
      </div>
    </footer>
  );
}
